const development_tenant = {
    notification: 'أنت في وضع التطوير',
};
export default Object.freeze(development_tenant);
